module.exports = __webpack_public_path__ + "static/media/notes.4623bd3c.png";